import "./css/SkillCard.scss";
import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";

function SkillCard(props) {
  return (
    <Card className="SkillCard d-inline-block">
      <Card.Header className="SkillCard__Header text-center">
        <div className="d-flex flex-column justify-content-between">
          <span className="fw-bold">{props.category.title}</span>
          {props.category.caption &&
            <span className="SkillCard__Header__Caption text-muted">{props.category.caption}</span>}
        </div>
      </Card.Header>
      <ListGroup variant="flush">
        {
          Object.values(props.category.skills).map((skill, index) =>
            <ListGroup.Item key={index}>
              <div className="d-flex justify-content-between gap-2">
                <span>{skill.name}</span>
                {skill.proficiency &&
                  <span className="text-muted">{skill.proficiency}</span>}
              </div>
              {skill.subSkills &&
                <div className="ms-4 d-flex flex-column text-muted">
                  {
                    Object.values(skill.subSkills).map((subSkill, index) =>
                      <span key={index}>{subSkill}</span>
                    )
                  }
                </div>}
            </ListGroup.Item>
          )
        }
      </ListGroup>
    </Card>
  );
}

export default SkillCard;